import 'css-chunksrc/client/pages/projectPage/exportsPage/dailyPlanningReport/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_jto6z_1",
  "input": "_input_jto6z_7",
  "toggleArrow": "_toggleArrow_jto6z_23",
  "selectedDataTypes": "_selectedDataTypes_jto6z_31",
  "placeholder": "_placeholder_jto6z_40",
  "list": "_list_jto6z_45",
  "item": "_item_jto6z_57",
  "typeName": "_typeName_jto6z_70",
  "opened": "_opened_jto6z_77"
};